import Lottie from 'react-lottie';
import lottieJson from './loading_mochi.json';
import styles from './index.module.sass';
import classname from 'classnames/bind';

const cx = classname.bind(styles);

const LoadingMochi = ({ show = false }) => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: lottieJson,
  };

  const loadingMochiClass = cx({
    'loading-mochi': true,
    show,
  });

  return (
    <div className={loadingMochiClass}>
      <Lottie width={70} height={70} options={options} />
    </div>
  );
};

export default LoadingMochi;
